import { List } from "immutable";
import * as M from "../models";

export interface AdminNavListState {
    loading: boolean;
    navItems: List<M.AdminNav.NavListItem>;
    types: List<M.Generic.TypeDefinition>;
}

export const initialState: AdminNavListState = {
    loading: true,
    navItems: List(),
    types: List(),
};



// WEBPACK FOOTER //
// ./src/store/AdminNavListState.ts